import React from 'react'
import Routes from "./main/Routes"
import ReactDOM from "react-dom"
import registerServiceWorker from "./main/utils/registerServiceWorker"

ReactDOM.render(<Routes />, document.getElementById('root'));

// PWA: install /sw.js so push, asset caching, and stale-while-revalidate API
// caching all become live. No-ops in CRA dev unless REACT_APP_ENABLE_SW=true.
registerServiceWorker();
